import { render } from "./AiTaskSections.vue?vue&type=template&id=05903063&scoped=true"
import script from "./AiTaskSections.vue?vue&type=script&lang=js"
export * from "./AiTaskSections.vue?vue&type=script&lang=js"

import "./AiTaskSections.vue?vue&type=style&index=0&id=05903063&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05903063"]])

export default __exports__